function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42 15.9998V31.9998C41.9993 32.7013 41.8141 33.3902 41.4631 33.9975C41.112 34.6048 40.6075 35.1091 40 35.4598L26 43.4598C25.6853 43.6415 25.3488 43.7786 25 43.8687V24.5968L41.8328 14.8596C41.9428 15.228 41.9996 15.612 42 15.9998ZM40.7995 13.1468C40.5605 12.9127 40.2922 12.7085 40 12.5398L26 4.5398C25.3919 4.18873 24.7021 4.00391 24 4.00391C23.2979 4.00391 22.6081 4.18873 22 4.5398L16.11 7.9055L33.0114 17.6519L40.7995 13.1468ZM14.1881 9.00377L8 12.5398C7.70789 12.7085 7.43958 12.9126 7.20069 13.1467L24.0002 22.8646L31.0127 18.8081L14.5006 9.28613C14.3734 9.21279 14.2685 9.11574 14.1881 9.00377ZM6.16724 14.8594L23 24.5965V43.8687C22.6512 43.7786 22.3147 43.6415 22 43.4598L8 35.4598C7.39252 35.1091 6.88796 34.6048 6.53692 33.9975C6.18589 33.3902 6.00072 32.7013 6 31.9998V15.9998C6.0004 15.6119 6.05719 15.2279 6.16724 14.8594Z",
  fill: "#3739B5"
});

var SvgFoodBoxDelivery = function SvgFoodBoxDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#FAFAFA",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoodBoxDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/food_box_delivery.49b06128.svg";
export { ForwardRef as ReactComponent };